import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

const NotFoundPage: React.FC = () => {
    const theme = useTheme();
    const dark = theme.palette.mode === 'dark';

    return (
        <Box sx={{ py: { xs: 8, md: 16 }, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
            <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
                <Typography variant="h1" sx={{
                    fontSize: { xs: '6rem', md: '10rem' }, fontWeight: 900, lineHeight: 1, mb: 2,
                    background: dark ? 'linear-gradient(135deg, #60A5FA, #A78BFA)' : 'linear-gradient(135deg, #2563EB, #7C3AED)',
                    backgroundClip: 'text', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                }}>404</Typography>

                <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: '1.3rem', md: '1.8rem' } }}>Page not found</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400, mx: 'auto' }}>The page you're looking for doesn't exist or has been moved.</Typography>

                <Box sx={{ bgcolor: dark ? '#0D1B2A' : '#1E293B', borderRadius: '16px', p: 3, mb: 4, textAlign: 'left', border: `1px solid ${dark ? '#1E293B' : '#334155'}` }}>
                    <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                        <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#EF4444' }} />
                        <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#F59E0B' }} />
                        <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#10B981' }} />
                    </Box>
                    <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '0.85rem', color: '#94A3B8', lineHeight: 2 }}>
                        <Box component="span" sx={{ color: '#10B981' }}>$</Box> curl -I https://alexpetrov.dev{window.location.pathname}<br />
                        <Box component="span" sx={{ color: '#EF4444' }}>HTTP/1.1 404 Not Found</Box><br />
                        <Box component="span" sx={{ color: '#60A5FA' }}>X-Suggestion:</Box> Try the homepage instead :)
                    </Typography>
                </Box>

                <Button component={RouterLink} to="/" variant="contained" size="large" startIcon={<HomeRoundedIcon />}
                        sx={{ px: 4, py: 1.5, background: 'linear-gradient(135deg, #2563EB, #7C3AED)', boxShadow: '0 4px 20px rgba(37,99,235,0.3)' }}>
                    Go Home
                </Button>
            </Container>
        </Box>
    );
};

export default NotFoundPage;
